import { Textarea, type TextareaProps } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { forwardRef } from 'react'

const textAreaId = crypto.randomUUID()

export const DynamicTextArea = forwardRef<
  HTMLTextAreaElement,
  Omit<TextareaProps, 'height' | 'h' | 'css'>
>(({ value, onChange, ...props }, ref) => {
  return (
    <Textarea
      ref={ref}
      id={textAreaId}
      value={value}
      onChange={(e) => onChange?.(e)}
      css={css`
        field-sizing: content;
        height: auto;
      `}
      {...props}
    />
  )
})
